var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "640px", persistent: "", scrollable: "" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _c("div", { staticClass: "title--text" }, [_vm._v("Đăng ký")]),
              _c("v-spacer"),
              _c(
                "v-icon",
                {
                  staticClass: "mr-n1",
                  on: {
                    click: function($event) {
                      return _vm.cancel()
                    }
                  }
                },
                [_vm._v("mdi-close")]
              )
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-text",
            { staticClass: "pt-4 pb-2" },
            [
              _c(
                "v-form",
                { ref: "form" },
                [
                  _c(
                    "div",
                    { staticClass: "text-subtitle-1 font-weight-medium mb-4" },
                    [
                      _vm._v(
                        "TÀI KHOẢN ĐĂNG KÝ TUYỂN SINH KHỐI " +
                          _vm._s(_vm.signUpGrade)
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "mb-4" },
                    [
                      _c("div", { staticClass: "text-subtitle-1" }, [
                        _vm._v("Họ và tên học sinh "),
                        _c("span", { staticClass: "required-mark" }, [
                          _vm._v("*")
                        ])
                      ]),
                      _c("v-text-field", {
                        attrs: {
                          placeholder: "VD: Nguyễn Văn A",
                          hint: "Gõ tiếng Việt có dấu, đúng quy tắc viết hoa",
                          "persistent-hint": "",
                          rules: [
                            _vm.$rules.required,
                            _vm.$rules.vietnameseName
                          ],
                          outlined: ""
                        },
                        model: {
                          value: _vm.studentName,
                          callback: function($$v) {
                            _vm.studentName = $$v
                          },
                          expression: "studentName"
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "text-subtitle-1" }, [
                    _vm._v("Ngày tháng năm sinh "),
                    _c("span", { staticClass: "required-mark" }, [_vm._v("*")])
                  ]),
                  _c(
                    "div",
                    { staticClass: "mb-8" },
                    [
                      _c("DobSplitTextInput", {
                        ref: "date-picker",
                        model: {
                          value: _vm.dob,
                          callback: function($$v) {
                            _vm.dob = $$v
                          },
                          expression: "dob"
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "text-subtitle-1" }, [
                    _vm._v(
                      " Địa chỉ thường trú (Số nhà, Đường/Phố, Xã/Phường, Thành phố) "
                    ),
                    _c("span", { staticClass: "required-mark" }, [_vm._v("*")])
                  ]),
                  _c("v-text-field", {
                    attrs: {
                      placeholder:
                        "VD: Số 56 Nguyễn Thị Định, phường Yên Hòa, thành phố Hà Nội",
                      rules: [_vm.$rules.required],
                      outlined: ""
                    },
                    model: {
                      value: _vm.address,
                      callback: function($$v) {
                        _vm.address = $$v
                      },
                      expression: "address"
                    }
                  }),
                  _c(
                    "div",
                    { staticClass: "mb-4" },
                    [
                      _c("div", { staticClass: "text-subtitle-1" }, [
                        _vm._v("Họ tên phụ huynh "),
                        _c("span", { staticClass: "required-mark" }, [
                          _vm._v("*")
                        ])
                      ]),
                      _c("v-text-field", {
                        attrs: {
                          placeholder: "Nhập tên phụ huynh tại đây",
                          hint: "Gõ tiếng Việt có dấu, đúng quy tắc viết hoa",
                          "persistent-hint": "",
                          rules: [
                            _vm.$rules.required,
                            _vm.$rules.vietnameseName
                          ],
                          outlined: ""
                        },
                        model: {
                          value: _vm.parentName,
                          callback: function($$v) {
                            _vm.parentName = $$v
                          },
                          expression: "parentName"
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "text-subtitle-1" }, [
                    _vm._v(" Số điện thoại PH (dùng để đăng nhập) "),
                    _c("span", { staticClass: "required-mark" }, [_vm._v("*")])
                  ]),
                  _c("v-text-field", {
                    directives: [
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: "##########",
                        expression: "'##########'"
                      }
                    ],
                    attrs: {
                      type: "tel",
                      placeholder:
                        "Nhập số điện thoại tại đây (Ví dụ: 097372xxxx)",
                      rules: _vm.phoneRules,
                      outlined: "",
                      "validate-on-blur": ""
                    },
                    model: {
                      value: _vm.phone,
                      callback: function($$v) {
                        _vm.phone = $$v
                      },
                      expression: "phone"
                    }
                  }),
                  _c("div", { staticClass: "text-subtitle-1" }, [
                    _vm._v("Email liên hệ "),
                    _c("span", { staticClass: "required-mark" }, [_vm._v("*")])
                  ]),
                  _c("v-text-field", {
                    attrs: {
                      placeholder: "VD: abcxyz@gmail.com",
                      rules: [_vm.$rules.required, _vm.$rules.email],
                      outlined: ""
                    },
                    model: {
                      value: _vm.parentEmail,
                      callback: function($$v) {
                        _vm.parentEmail = $$v
                      },
                      expression: "parentEmail"
                    }
                  }),
                  _c("v-divider"),
                  _c("div", { staticClass: "text-subtitle-1 mt-5" }, [
                    _vm._v("Mật khẩu "),
                    _c("span", { staticClass: "required-mark" }, [_vm._v("*")])
                  ]),
                  _c("v-text-field", {
                    attrs: {
                      placeholder: "PH tự tạo mật khẩu",
                      "append-icon": _vm.showPassword
                        ? "mdi-eye"
                        : "mdi-eye-off",
                      type: _vm.showPassword ? "text" : "password",
                      rules: _vm.passwordRules,
                      outlined: "",
                      "validate-on-blur": ""
                    },
                    on: {
                      "click:append": function($event) {
                        _vm.showPassword = !_vm.showPassword
                      }
                    },
                    model: {
                      value: _vm.password,
                      callback: function($$v) {
                        _vm.password = $$v
                      },
                      expression: "password"
                    }
                  }),
                  _c("div", { staticClass: "text-subtitle-1" }, [
                    _vm._v("Mật khẩu (nhắc lại) "),
                    _c("span", { staticClass: "required-mark" }, [_vm._v("*")])
                  ]),
                  _c("v-text-field", {
                    attrs: {
                      placeholder: "Nhập lại mật khẩu tại đây",
                      "append-icon": _vm.showConfirmPassword
                        ? "mdi-eye"
                        : "mdi-eye-off",
                      type: _vm.showConfirmPassword ? "text" : "password",
                      rules: _vm.confirmPasswordRules,
                      outlined: "",
                      "validate-on-blur": ""
                    },
                    on: {
                      "click:append": function($event) {
                        _vm.showConfirmPassword = !_vm.showConfirmPassword
                      }
                    },
                    model: {
                      value: _vm.confirmPassword,
                      callback: function($$v) {
                        _vm.confirmPassword = $$v
                      },
                      expression: "confirmPassword"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-actions",
            { staticClass: "flex-column" },
            [
              _c(
                "v-btn",
                {
                  staticClass:
                    "white--text text-subtitle-1 mt-4 text-none full-width",
                  attrs: {
                    depressed: "",
                    "x-large": "",
                    color: "primary",
                    loading: _vm.loading
                  },
                  on: { click: _vm.submit }
                },
                [_vm._v(" Đăng ký ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass:
                    "text-subtitle-1 font-weight-bold mt-2 text-none full-width",
                  attrs: { plain: "", "x-large": "", color: "primary" },
                  on: { click: _vm.signin }
                },
                [_vm._v(" Đã có tài khoản? Đăng nhập ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }